import React from "react";
import { RotateCw } from "lucide-react";

/**
 * Small refresh button used in admin list/detail pages.
 * `onClick` triggers re-fetch. While `loading`, spins.
 */
export default function RefreshButton({ onClick, loading, label = "Refresh", testid = "refresh-button" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="inline-flex items-center gap-2 border border-[#2a2a2d] text-[#9a9787] hover:text-[#c3ba9e] hover:border-[#c3ba9e]/50 px-4 py-2.5 text-[11px] tracking-[0.28em] uppercase transition-colors disabled:opacity-60"
      data-testid={testid}
      aria-label={label}
    >
      <RotateCw size={13} className={loading ? "animate-spin" : ""} />
      {loading ? "Refreshing…" : label}
    </button>
  );
}
